import { put, call } from 'redux-saga/effects';
import BseDataRepository from '../../../../data/repositories/BseDataRepository';
import BseRepository from '../../../repositories/BseRepository';
import { Types } from './actions';
import { Creators } from '../processBseUseCase/actions';
import { Creators as GetFormBSEActions } from '../getFormBseUseCase/actions';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

const repository: BseRepository = new BseDataRepository();

export default function* execute({
  idRequest,
  data,
  processAfterUpload
}: any): any {
  try {
    yield put({ type: Types.UPLOAD_BSE_DOCUMENT_REQUEST });

    if (Array.isArray(data)) {
      let index = 0;
      const response: any[] = [];
      while (index < data.length) {
        XCheckpointManager.registerStart('BSE - Upload document');
        response[index] = yield call(
          repository.uploadBseDocument,
          idRequest,
          data[index]
        );
        XCheckpointManager.registerEnd('BSE - Upload document');
        index += 1;
      }
    } else {
      XCheckpointManager.registerStart('BSE - Upload document');
      const response2 = yield call(
        repository.uploadBseDocument,
        idRequest,
        data
      );
      XCheckpointManager.registerEnd('BSE - Upload document');
      if (!response2) {
        yield put({
          type: Types.UPLOAD_BSE_DOCUMENT_FAILURE,
          error: true
        });
        return;
      }
    }
    yield put(GetFormBSEActions.getFormBse(parseInt(idRequest, 10)));
    yield put({
      type: Types.UPLOAD_BSE_DOCUMENT_SUCCESS,
      data: [{ status: 'OK' }]
    });
    if (processAfterUpload) {
      yield put(Creators.processFormBse(idRequest.toString()));
    }
  } catch (error) {
    yield put({
      type: Types.UPLOAD_BSE_DOCUMENT_FAILURE,
      error: 'Ocurrió un error al momento de cargar los documentos.'
    });
  }
}
